import React, { useState } from 'react';
import './FAQ.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Plus, X } from "lucide-react";


const FAQ = ({ faqContent }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = index => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className='container'>
      <div className='faq'>
        <div className='row'>
      <h2 style={{textAlign: 'center', fontWeight: '700', fontSize: '2em', marginBottom: '10px'}}>FAQs</h2>
      <p style={{textAlign: 'center', color: '#777', marginBottom: '20px' }}>{faqContent?.title || 'Got Questions? We\'ve Got Answers'}.</p>
      </div>
      <div className='faq-items'>
      {(faqContent?.questions || []).map((question, index) => (
        <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>  
          <div
            className='faq-question'
            onClick={() => toggleFAQ(index)}
          >
            {question.q}
            <span>{activeIndex === index ? <X className='text-danger' /> : <Plus className='text-success' />}</span>
          </div>
          {activeIndex === index && <div className='faq-answer'>{question.a}</div>}
        </div>
      ))}
      </div>
      </div>
    </div>
  );
};

export default FAQ;
